 <template>
    <!-- MAIN -->
    <section class="section">
    <div class="columns" id="main">
        <side-menu class="column is-2" 
        :header="adminHeader" 
        :items="actions" 
        :selectedItemId="actionId"
        v-on:elementClick="toggleAdmin"></side-menu>
        <!-- CONTENT -->
        <main class="container column is-8 main">
        
          
            <import-partial v-if="actionId == 0" />
            <restore-partial v-else />

          

            <loading :active.sync="loading" 
            :can-cancel="false" 
            :is-full-page="false"></loading>        
        </main>
        
    </div>    
    </section>
    <!-- END MAIN -->
</template>

<script>
import SideMenu from "../SideMenu";
import ImportPartial from "../ImportPartial";
import RestorePartial from "../RestorePartial";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.min.css";

export default {
  name: "admin-view",
  components: { SideMenu, Loading, ImportPartial, RestorePartial },
  data() {
    return {
      adminHeader: "Actions",
      actions: [
        {
          id: 0,
          name: "Import"
        },
        {
          id: 1,
          name: "Manage deleted entries"
        }
      ],
      actionId: 0,
      productId: -1,
      loading: false
    };
  },
  methods: {
    toggleAdmin(id) {
      this.actionId = id;
    },
    pushUrl() {
      this.$router.push({
        path: "admin",
        query: {
          actionId: this.actionId,
          productId: this.productId
        }
      });
    }
  },
  created() {
    let id = parseInt(this.$route.query.actionId);
    if (id) {
      this.actionId = id;
    } else {
      this.actionId = 0;
    }
    console.log("productId");
    console.log(parseInt(this.$route.query.productId));
    let pId = parseInt(this.$route.query.productId);
    if (pId > 0) this.productId = pId;

    this.pushUrl();
  },
  watch: {
    $route(to, from) {
      this.actionId = parseInt(to.query.actionId);
    },
    actionId: function(val) {
      this.pushUrl();
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/views/AdminPanel.Vue